import { flexStyle } from '@themes/mixins';
import styled from 'styled-components';

export const AdornmentsContainer = styled.div`
  ${flexStyle({
    align: 'center',
    direction: 'row',
    justify: 'end',
    wrap: 'nowrap',
  })};
`;
export const PostfixContainer = styled.div`
  display: inline-flex;
  align-items: center;
  padding-left: 6px;
  margin-left: 6px;
`;
